import {MobileTaskSelectionType} from "@/shared/timrTypes";

export interface TaskSelectionConfigurationComponentData {
	availableTaskSelectionTypes: MobileTaskSelectionType[];
	selectedTaskSelectionTypes: MobileTaskSelectionType[];
	openSearchInAll: boolean;
	startOnSelection: boolean;
	openAutomatically: boolean;
	visible?: boolean;
}

export class TaskSelectionConfigurationComponent extends HTMLElement {

	private _defaultTaskSpecified: boolean = false;

	private _config: TaskSelectionConfigurationComponentData = {
		availableTaskSelectionTypes: [],
		selectedTaskSelectionTypes: [],
		openSearchInAll: false,
		startOnSelection: false,
		openAutomatically: false,
		visible: false
	};

	set defaultTaskSpecified(defaultTaskSpecified: boolean) {
		this._defaultTaskSpecified = defaultTaskSpecified;
		const checkboxOpenAutomatically = $(this.querySelector<HTMLElement>("#openAutomaticallyCheckbox"));
		if (defaultTaskSpecified) {
			checkboxOpenAutomatically.prop("checked", false);
		}
		checkboxOpenAutomatically.prop("disabled", defaultTaskSpecified);
	}

	get config(): TaskSelectionConfigurationComponentData {
		return this._config;
	}

	set config(config: TaskSelectionConfigurationComponentData) {
		this._config = config;
		this.render();
	}

	public changeVisibility(visible: boolean) {
		// update enabled state of the component
		this.config = {...this._config, visible};
	}

	public getData(): {
		taskSelectionTypes: MobileTaskSelectionType[],
		openAutomatically: boolean,
		startOnSelection: boolean,
		openSearchInAll: boolean
	} {
		return {
			taskSelectionTypes: this.getTaskSelectionTypes(),
			openAutomatically: $(this.querySelector<HTMLElement>("#openAutomaticallyCheckbox")).is(":checked"),
			startOnSelection: $(this.querySelector<HTMLElement>("#startOnSelectionCheckbox")).is(":checked"),
			openSearchInAll: $(this.querySelector<HTMLElement>("#openSearchInAllCheckbox")).is(":checked")
		}
	}

	private getTaskSelectionTypes(): MobileTaskSelectionType[] {
		return $(this.querySelector<HTMLElement>("#selectedTaskSelectionTypes")).sortable("toArray") as MobileTaskSelectionType[];
	}

	private updateTaskSelectionConfigList() {
		const selectedList = $(this.querySelector<HTMLElement>("#selectedTaskSelectionTypes"));
		const unselectedList = $(this.querySelector<HTMLElement>("#unselectedTaskSelectionTypes"));
		selectedList.empty();
		unselectedList.empty();

		const selectedTaskSelectionTypes = this.config.selectedTaskSelectionTypes ? this.config.selectedTaskSelectionTypes : [MobileTaskSelectionType.ALL];
		selectedTaskSelectionTypes.forEach(taskSelectionType => {
			const divContent = $("<div>").addClass("mr-10").text(`${messages[`admin.clientSettings.mobileTaskSelectionType.${taskSelectionType}`]}`);
			const icon = $("<i>").addClass("fal fa-bars").attr("aria-hidden", "true");
			const liElement = $("<li>")
				.attr("title", `${messages[`admin.clientSettings.mobileTaskSelectionType.title.${taskSelectionType}`]}`)
				.attr("id", taskSelectionType)
				.append(divContent);

			if (taskSelectionType === MobileTaskSelectionType.ALL) {
				const label = $("<label>").addClass("checkbox-inline").attr("for", "openSearchInAllCheckbox")
				const input = $("<input>").attr("type", "checkbox").attr("id", "openSearchInAllCheckbox").attr("name", "openSearchInAll").prop("checked", this.config.openSearchInAll);
				label.append(input);
				label.append(`${messages["admin.clientSettings.mobileOpenSearchInAll.checkbox"]}`)
				liElement.append(label);
			}
			liElement.append(icon);
			selectedList.append(liElement);
		});

		const inactiveTaskSelectionTypes = this.config.availableTaskSelectionTypes.filter(taskSelectionType => selectedTaskSelectionTypes.indexOf(taskSelectionType) === -1);
		inactiveTaskSelectionTypes.filter(it => it !== MobileTaskSelectionType.ALL).forEach(taskSelectionType => {
			const divContent = $("<div>").addClass("mr-10").text(`${messages[`admin.clientSettings.mobileTaskSelectionType.${taskSelectionType}`]}`);
			const icon = $("<i>").addClass("fal fa-bars").attr("aria-hidden", "true");
			const liElement = $("<li>")
				.attr("title", `${messages[`admin.clientSettings.mobileTaskSelectionType.title.${taskSelectionType}`]}`)
				.attr("id", taskSelectionType)
				.append(divContent)
				.append(icon);
			unselectedList.append(liElement);
		});

		this.initTaskSelectionTypesSortable();
	}

	private initTaskSelectionTypesSortable() {
		const unselectedEmptyIndicator = $(this.querySelector<HTMLElement>("#unselectedEmptyIndicator"));
		const selectedList = $(this.querySelector<HTMLElement>("#selectedTaskSelectionTypes"));
		const unselectedList = $(this.querySelector<HTMLElement>("#unselectedTaskSelectionTypes"));

		// Initialize sortable functionality using jQuery
		$(selectedList).add(unselectedList).sortable({
			connectWith: ".connectedSortable",
			receive: (event, ui) => {
				// Prevent moving the 'ALL' item to the unselected list
				if (ui.sender.is("#selectedTaskSelectionTypes") && ui.item.attr("id") === "ALL") {
					ui.sender.sortable("cancel");
					ui.item.removeClass("cursor-not-allowed");
				}

				// show "no entries" message if unselected items list is empty
				unselectedEmptyIndicator.toggle(!ui.sender.is("#selectedTaskSelectionTypes") && ui.sender.find("li").length === 0);
			},
			over: (event, ui) => {
				// Show a "not-allowed" cursor if item 'ALL' is moving into the unselected list
				if (ui.item.attr("id") === "ALL") {
					ui.item.toggleClass("cursor-not-allowed", event.target.id !== "selectedTaskSelectionTypes");
				}
			},
		}).disableSelection();
	}

	private render() {
		this.innerHTML = `
      <div id="taskSelectionTypesCollapse" class="panel-collapse collapse ${this.config.visible ? "in" : ""}">
        <div class="form-group mb-10">
          <div class="col-lg-9 col-lg-offset-3">
            <div class="mobile-task-selection-sortable">
              <div class="row display-flex">
                <div class="col-lg-6">
                  <div>${messages["admin.clientSettings.mobileTaskSelectionType.selected"]}</div>
                  <ul id="selectedTaskSelectionTypes" class="selectable-demo-list connectedSortable">
                  </ul>
                </div>
                
                <div class="col-lg-6">
                  <div>${messages["admin.clientSettings.mobileTaskSelectionType.selection"]}</div>
                  <div id="unselectedEmptyIndicator" class="text-grey" style="display: none">${messages["tree.empty"]}</div>
                  <ul id="unselectedTaskSelectionTypes" class="selectable-demo-list connectedSortable">
                  </ul>
                </div>
              </div>
              
              <div class="row text-left">
                <div class="input-info-text ml-10">
                  <i class="far fa-info-circle position-left" aria-hidden="true"></i>
                  ${messages["admin.clientSettings.mobileTaskSelectionType.info"]}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-md-9 col-md-offset-3">
            <label class="form-group checkbox-inline" for="openAutomaticallyCheckbox">
              <input type="checkbox" id="openAutomaticallyCheckbox" name="openAutomatically" ${
			this.config.openAutomatically ? "checked" : " "}${this._defaultTaskSpecified ? "disabled" : ""}/>
              ${messages["admin.clientSettings.openAutomatically.checkbox"]}
            </label>
            <div class="input-info-text">
              <i class="far fa-info-circle position-left" aria-hidden="true"></i>
              ${messages["admin.clientSettings.openAutomatically.info"]}
            </div>
          </div>
        </div>
        <div class="form-group no-margin-bottom">
          <div class="col-md-9 col-md-offset-3">
            <label class="form-group checkbox-inline" for="startOnSelectionCheckbox">
              <input type="checkbox" id="startOnSelectionCheckbox" name="startOnSelection" ${
			this.config.startOnSelection ? "checked" : ""
		}/>
              ${messages["admin.clientSettings.mobileStartOnSelection.checkbox"]}
            </label>
            <div class="input-info-text">
              <i class="far fa-info-circle position-left" aria-hidden="true"></i>
              ${messages["admin.clientSettings.mobileStartOnSelection.info"]}
            </div>
          </div>
        </div>
      </div>`;

		this.updateTaskSelectionConfigList();
	}
}
